"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// write code here
var table = document.querySelector("table");
var tHead = table.querySelector("thead");
var tBody = table.querySelector("tbody");
var titles = tHead.querySelectorAll("th");
var form = document.createElement("form");
function getRows() {
    return Array.from(document.querySelectorAll("tbody tr"));
}
var getNumber = function(value) {
    return +value.replaceAll(/[$,]/g, "");
};
var sortAsc = function(content, index) {
    return content.sort(function(a, b) {
        var valA = a.children[index].textContent;
        var valB = b.children[index].textContent;
        if (!isNaN(getNumber(valA)) && !isNaN(getNumber(valB))) return getNumber(valA) - getNumber(valB);
        else return valA.localeCompare(valB);
    });
};
var sortDesc = function(content, index) {
    return content.sort(function(a, b) {
        var valA = a.children[index].textContent;
        var valB = b.children[index].textContent;
        if (!isNaN(getNumber(valA)) && !isNaN(getNumber(valB))) return getNumber(valB) - getNumber(valA);
        else return valB.localeCompare(valA);
    });
};
var lastSortedIndex = null;
var counter = 1;
titles.forEach(function(title, index) {
    title.addEventListener("click", function() {
        var rows = getRows();
        var sortedRows;
        if (lastSortedIndex === index && counter % 2 === 0) sortedRows = sortDesc(_to_consumable_array(rows), index);
        else sortedRows = sortAsc(_to_consumable_array(rows), index);
        counter++;
        sortedRows.forEach(function(row) {
            return tBody.appendChild(row);
        });
        lastSortedIndex = index;
    });
});
var previouslyActiveRow = null;
document.querySelector("tbody").addEventListener("click", function(e) {
    var row = e.target.closest("tr");
    if (row) {
        previouslyActiveRow === null || previouslyActiveRow === void 0 ? void 0 : previouslyActiveRow.classList.remove("active");
        row.classList.add("active");
        previouslyActiveRow = row;
    }
});
var addForm = function() {
    var fields = [
        "name",
        "position",
        "age",
        "salary"
    ];
    var selectOptions = [
        "Tokyo",
        "Singapore",
        "London",
        "New York",
        "Edinburgh",
        "San Francisco"
    ];
    form.classList.add("new-employee-form");
    form.setAttribute("novalidate", "");
    fields.forEach(function(nameField) {
        var label = document.createElement("label");
        form.appendChild(label);
        label.textContent = nameField.charAt(0).toUpperCase() + nameField.slice(1);
        var input = document.createElement("input");
        if (nameField === "age" || nameField === "salary") input.setAttribute("type", "number");
        else input.setAttribute("type", "text");
        input.setAttribute("name", nameField);
        input.setAttribute("data-qa", nameField);
        label.append(input);
        input.required = true;
    });
    var createSelect = function(nameField, options) {
        var label = document.createElement("label");
        form.appendChild(label);
        label.textContent = nameField.charAt(0).toUpperCase() + nameField.slice(1);
        var select = document.createElement("select");
        select.setAttribute("name", nameField);
        select.setAttribute("data-qa", nameField);
        label.append(select);
        select.required = true;
        options.forEach(function(option, index) {
            var optionEl = document.createElement("option");
            optionEl.setAttribute("value", option);
            optionEl.textContent = option.charAt(0).toUpperCase() + option.slice(1);
            select.appendChild(optionEl);
        });
    };
    createSelect("office", selectOptions);
    var fieldsAll = form.querySelectorAll("input, textarea, select");
    fieldsAll.forEach(function(el) {
        return el.required = true;
    });
    var createButton = function(type, title) {
        var button = document.createElement("button");
        button.setAttribute("type", type);
        button.textContent = title;
        form.appendChild(button);
    };
    createButton("submit", "Save to table");
    table.after(form);
};
addForm();
var createNotification = function(type, description) {
    var existNtf = document.querySelector('[data-qa="notification"]');
    if (existNtf) existNtf.remove();
    if (type !== "success" && type !== "error") throw new Error("Invalid notification type: ".concat(type));
    var ntf = document.createElement("div");
    ntf.setAttribute("data-qa", "notification");
    ntf.classList.add("notification");
    ntf.classList.add(type === "success" ? "success" : "error");
    ntf.setAttribute("data-qa", "notification");
    var ntfTitle = document.createElement("h2");
    ntfTitle.classList.add("title");
    ntfTitle.textContent = type === "success" ? "Success" : "Error";
    ntf.appendChild(ntfTitle);
    var ntfDesc = document.createElement("div");
    ntfDesc.classList.add("description");
    ntfDesc.textContent = description;
    ntf.appendChild(ntfDesc);
    document.body.appendChild(ntf);
};
var checkValidation = function(formEl) {
    var nameInput = formEl.elements.name;
    var ageInput = formEl.elements.age;
    var positionInput = formEl.elements.position;
    if (nameInput.value.length < 4) {
        createNotification("error", 'The field "Name" has fewer than 4 letters');
        return false;
    }
    if (positionInput.value.length === 0) {
        createNotification("error", 'The field "Position" cannot be empty');
        return false;
    }
    if (ageInput.value < 18 || ageInput.value > 90) {
        createNotification("error", "Age must be between 18 and 90");
        return false;
    }
    createNotification("success", "A new employee is added to the table");
    return true;
};
// actions by clicking form submit btn
form.addEventListener("submit", function(e) {
    e.preventDefault();
    var isCustomValid = checkValidation(form);
    if (isCustomValid === false) return;
    var formData = new FormData(form);
    var newRow = document.createElement("tr");
    tBody.appendChild(newRow);
    var titlesContent = _to_consumable_array(titles).map(function(el) {
        return el.textContent.toLowerCase();
    });
    for(var i = 0; i < titlesContent.length; i++){
        var newCell = document.createElement("td");
        newRow.appendChild(newCell);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = _sliced_to_array(_step.value, 2), nameField = _step_value[0], value = _step_value[1];
            var newCells = newRow.querySelectorAll("td");
            titlesContent.forEach(function(el, index) {
                if (el === nameField.toLocaleLowerCase()) {
                    if (el === "salary") newCells[index].textContent = "$".concat(Number(value).toLocaleString("en-US"));
                    else newCells[index].textContent = !isNaN(+value) ? +value : value;
                }
            });
        };
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    form.reset();
});
document.querySelector("tbody").addEventListener("dblclick", function(e) {
    var cell = e.target.closest("td");
    var columnIndex = cell.cellIndex;
    var columnName = titles[columnIndex].textContent.toLowerCase();
    if (!cell || cell.querySelector("input")) return;
    var existInput = document.querySelector(".cell-input");
    if (existInput) existInput.blur();
    var cellOriginalValue = cell.textContent;
    cell.textContent = "";
    var input = document.createElement("input");
    input.classList.add("cell-input");
    input.value = cellOriginalValue;
    cell.appendChild(input);
    input.focus();
    var saveState = function() {
        var value = input.value;
        if (value === "") cell.textContent = cellOriginalValue;
        else cell.textContent = value;
        if (columnName === "salary") cell.textContent = "$".concat(Number(value).toLocaleString("en-US"));
    };
    input.addEventListener("blur", saveState);
    input.addEventListener("keydown", function(evt) {
        if (evt.key === "Enter") saveState();
    });
});

//# sourceMappingURL=index.4410d260.js.map
